// extracted by mini-css-extract-plugin
export default {"actions":"actions--EAxcr"};